import http from "@/tools/http";

export default {
  getAll(organizationUUID, pagination) {
    return http.get(`/organizations/${organizationUUID}/customers`, { params: pagination });
  },
  delete(organizationUUID, customerUUID) {
    return http.delete(`/organizations/${organizationUUID}/customers/${customerUUID}`);
  },
  getAllNotes(orgUUID, customerUuid) {
    return http.get(`/organizations/${orgUUID}/customers/${customerUuid}/notes`);
  },
  createNotes(orgUUID, customerUuid, text) {
    return http.post(`/organizations/${orgUUID}/customers/${customerUuid}/notes`, { text });
  },
  deleteNotes(orgUUID, customerUuid, noteUuid) {
    return http.delete(`/organizations/${orgUUID}/customers/${customerUuid}/notes/${noteUuid}`);
  },
  getCustomerMetadata(organizationUUID, customerUUID) {
    return http.get(`/organizations/${organizationUUID}/customers/${customerUUID}/metadata`);
  },
  updateCustomerMetadata(organizationUUID, customerUUID, metadataUUID, value) {
    return http.patch(`/organizations/${organizationUUID}/customers/${customerUUID}/metadata/${metadataUUID}`, {
      value: value
    });
  },
  unsubscribe({ organizationUUID, customerUUID, distributionUUID, data }) {
    return http.patch(`/unsubscribe/${organizationUUID}/${customerUUID}/${distributionUUID}`, data);
  }
};
